import Accordion from '@components/Accordion';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import useProject from '@hooks/useProject';

import { GiftNote } from './notes';

interface Props {
    notes: GiftNote[];
}

function GiftNotes({ notes }: Props) {
    const storeName = useProject()?.name ?? '';

    return (
        <Container>
            {notes.map(({ title, items }) => (
                <Accordion key={title}
                    initialOpen
                    title={<Text size='body-short' fontWeight='medium' color={colors.textSecondary}>{title}</Text>}>
                    <List>
                        {items.map((item, index) => (
                            <li key={index}>
                                <Text size='body-long' color={colors.textSecondary} multiline>
                                    {item.replace(/\{storeName\}/g, storeName)}
                                </Text>
                            </li>
                        ))}
                    </List>
                </Accordion>
            ))}
        </Container>
    );
}

const Container = styled.footer`
    width: 100%;
`;

const List = styled.ul`
    color: var(--color-text-secondary);
    font-size: var(--font-size-body-long);
    list-style: disc;
    margin: 0;
    padding-left: var(--spacing-4);
`;

export default GiftNotes;
